module.exports = __webpack_public_path__ + "img/add_subScript_icon.f98f6d3e.svg";